import * as React from "react";
import { DatePicker } from "../../../../../../../react-core/Datepicker/DatePicker";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { UkPostCode } from "../../../../../../../react-core/Html/Validation/RegExPatterns";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { Title } from "../../../../../../../Wrap/Constants/Enums/Title";
import { ExternalAssetsOwner } from "../../../../../../../Wrap/Models/Domains/Transfer/ExternalAssetsOwner";
import { ClientDetails } from "../../../../../../../Wrap/Models/Models/Processes/Quote/ClientDetails";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { ACCEPT_DATE_FORMATS, ContentDatePicker } from "../../../../../../Shared/Entities/Constants/DateConstants";
import { TitleMap } from "../../../../../../Shared/Entities/Maps/TitleMap";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { CertificatedSharesAndEquityText, RegisteredOwnersText } from "../../Resource/Contents";

interface ICertificatedSharesAndEquityProps extends IProcessComponentProps {
    isCertificated: boolean;
    clientDetails: ClientDetails;
    data: ExternalAssetsOwner;
}

interface ICertificatedSharesAndEquityState {
    heldInOwnName: boolean;
}

export class CertificatedSharesAndEquity extends ProcessComponent<
    ICertificatedSharesAndEquityProps,
    ICertificatedSharesAndEquityState
> {
    constructor(props: any) {
        super(props);
        this.state = { heldInOwnName: false };
    }

    public render(): JSX.Element {
        const { onChange, data } = this.props;
        if (this.props.isCertificated) {
            return (
                <div>
                    <p>{CertificatedSharesAndEquityText}</p>

                    <h3>Ownership details</h3>
                    <CheckboxGroup
                        type="block"
                        wrapCss="mb-0"
                        options={[
                            {
                                label: "Held in own name",
                                value: this.state.heldInOwnName,
                                onChange: (v) => {
                                    this.setState({ heldInOwnName: v });
                                    if (v) {
                                        this.onDataChange(
                                            onChange,
                                            {
                                                Given: this.props.clientDetails.FirstName,
                                                Family: this.props.clientDetails.LastName,
                                                Title: Title.NotSpecified,
                                            },
                                            data,
                                            "OwnerName"
                                        );

                                        this.onDataChange(
                                            onChange,
                                            {
                                                Line1: this.props.clientDetails.Address.Address1,
                                                Line2: this.props.clientDetails.Address.Address2,
                                                Line3: this.props.clientDetails.Address.Address3,
                                                Line4: this.props.clientDetails.Address.Address4,
                                                Postcode: this.props.clientDetails.Address.PostCode,
                                            },
                                            data,
                                            "OwnerAddress"
                                        );
                                    }
                                },
                            },
                        ]}
                    />
                    <p>Registered owner</p>

                    <TextBoxEditor
                        cssWrapper="control-size-430"
                        label="First name"
                        value={data?.OwnerName?.Given}
                        onChange={(v) => {
                            this.onDataChange(onChange, { Given: v }, data, "OwnerName");
                        }}
                        disabled={this.state.heldInOwnName}
                        required={"Please enter first name"}
                    />
                    <TextBoxEditor
                        cssWrapper="control-size-430"
                        label="Surname name"
                        value={data?.OwnerName?.Family}
                        onChange={(v) => {
                            this.onDataChange(onChange, { Family: v }, data, "OwnerName");
                        }}
                        disabled={this.state.heldInOwnName}
                        required={"Please enter family name"}
                    />
                    <p>{RegisteredOwnersText}</p>

                    <TextBoxEditor
                        cssWrapper="control-size-430"
                        label={"Address line 1"}
                        value={data?.OwnerAddress?.Line1}
                        required={"Please enter address line 1"}
                        onChange={(v) => {
                            this.onDataChange(onChange, { Line1: v }, data, "OwnerAddress");
                        }}
                    />
                    <TextBoxEditor
                        cssWrapper="control-size-430"
                        label={"Address line 2"}
                        value={data?.OwnerAddress?.Line2}
                        required={"Please enter address line 2"}
                        onChange={(v) => {
                            this.onDataChange(onChange, { Line2: v }, data, "OwnerAddress");
                        }}
                    />
                    <TextBoxEditor
                        cssWrapper="control-size-430"
                        label="Address line 3"
                        value={data?.OwnerAddress?.Line3}
                        onChange={(v) => {
                            this.onDataChange(onChange, { Line3: v }, data, "OwnerAddress");
                        }}
                    />
                    <TextBoxEditor
                        cssWrapper="control-size-430"
                        label="Address line 4"
                        value={data?.OwnerAddress?.Line4}
                        onChange={(v) => {
                            this.onDataChange(onChange, { Line4: v }, data, "OwnerAddress");
                        }}
                    />
                    <TextBoxEditor
                        cssWrapper="control-size-430"
                        label="Post code"
                        value={data?.OwnerAddress?.Postcode}
                        required={"Please enter postcode"}
                        regex={{ errorMessage: "Please enter valid postcode", value: UkPostCode }}
                        onChange={(v) => this.onDataChange({ PostCode: v }, data, "OwnerAddress")}
                    />
                </div>
            );
        } else {
            return (
                <div>
                    <h3>Ownership details</h3>
                    <SelectEditor
                        cssWrapper="control-size-430"
                        options={["1"]}
                        getText={(v) => {
                            return v;
                        }}
                        label="Number of owners"
                        selected={"1"}
                        onChange={(v) => {}}
                        disabled={true}
                    />
                    <p>The names of the registered owner(s) must be given in full</p>
                    <SelectEditor
                        options={TitleMap.getTitleArrayAsString()}
                        cssWrapper="control-size-430"
                        placeholder="Please select"
                        selected={data?.OwnerName?.Title}
                        label={"Title"}
                        getText={(option) => {
                            return option;
                        }}
                        onChange={(v) => this.onDataChange(onChange, { Title: v }, data, "OwnerName")}
                        required={"Please select"}
                    />
                    <TextBoxEditor
                        cssWrapper="control-size-430"
                        label="First name"
                        value={data?.OwnerName?.Given}
                        onChange={(v) => {
                            this.onDataChange(onChange, { Given: v }, data, "OwnerName");
                        }}
                        required={"Please enter first name"}
                    />
                    <TextBoxEditor
                        cssWrapper="control-size-430"
                        label="Surname"
                        value={data?.OwnerName?.Family}
                        onChange={(v) => {
                            this.onDataChange(onChange, { Family: v }, data, "OwnerName");
                        }}
                        required={"Please enter family name"}
                    />
                    <DatePicker
                        formGroupCssWrapper="control-size-430"
                        selected={JsonDateParser.toDateNoOffset(data?.DateOfBirth)}
                        label={"Date of birth"}
                        atLeast={{
                            value: new Date(new Date().setFullYear(new Date().getFullYear() - 120)),
                            errorMessage: ContentDatePicker.CannotBeInThePast,
                        }}
                        atMost={{
                            value: new Date(),
                            errorMessage: ContentDatePicker.CannotBeInTheFuture,
                        }}
                        onChange={(v) => {
                            onChange({ DateOfBirth: JsonDateParser.toJsonDateNoOffset(new Date(Date.UTC(v.getFullYear(), v.getMonth(), v.getDate()))) });
                        }}
                        todayButton={ContentDatePicker.Today}
                        isClearable={true}
                        showYearDropdown={true}
                        dateFormat={ContentDatePicker.DateFormat}
                        acceptDateFormats={ACCEPT_DATE_FORMATS}
                        required="Please select date of birth"
                    />
                </div>
            );
        }
    }
}
